import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { PIREPS_LEGEND } from './pireps.legend';
import { PIREPS_PRODUCT_DATA } from './pireps.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class PirepsPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(PIREPS_PRODUCT_DATA, {
    legend: PIREPS_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
